import { axiosClient } from '../clients/axiosClient.js';
import { AXIZ_API_ROUTES } from '../constants/apiRoutes.js';
import { logger } from '@digiwedge/logger';
/**
 * Fetches a paginated list of sales orders with optional filtering.
 * @param filters - Filtering and pagination parameters.
 * @returns A list of sales orders.
 */
export const fetchSalesOrders = async (filters) => {
    try {
        const response = await axiosClient.get(AXIZ_API_ROUTES.SALES_ORDERS.GET_ALL, { params: filters });
        return response.data.result.items; // ✅ Unwrapping response.result.items
    }
    catch (error) {
        logger.error('Error fetching sales orders', { error });
        throw error;
    }
};
/**
 * Fetches a specific sales order by ID.
 * @param salesOrderId - The ID of the sales order.
 * @returns The details of the specified sales order.
 */
export const fetchSalesOrderById = async (salesOrderId) => {
    try {
        const response = await axiosClient.get(`${AXIZ_API_ROUTES.SALES_ORDERS.GET_BY_ID}?id=${salesOrderId}`);
        return response.data.result; // ✅ Unwrapping response.result
    }
    catch (error) {
        logger.error('Error fetching sales order', { error });
        throw error;
    }
};
//# sourceMappingURL=salesOrders.js.map